module.exports = __webpack_public_path__ + "img/ic_julio_console.68c95075.svg";